module.exports = __webpack_public_path__ + "img/floppy-disks.40b4cca6.svg";